import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Cushion,
  FlexContainer,
  Panel,
  Rectangle,
  ScrollBox,
  Typography,
} from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';
import TokenRedirect from '../token-redirect-link/route';

const JoinClubPanel = ({ isOpen, onClose }) => (
  <Panel isOpen={isOpen} onClose={onClose}>
    <Rectangle fill="seashellgrey" component="div" style={{ height: '100%' }}>
      <ScrollBox yOnly>
        <Cushion horizontal="medium" vertical="xlarge">
          <FlexContainer flexDirection="column" alignItems="center">
            <Typography
              align="center"
              preset="title"
              color="black"
              component="div"
              style={{ width: '100%' }}
            >
              <Trans i18nkey="common:join_to_set_attendance">Join to set attendance</Trans>
            </Typography>
            <Cushion vertical="medium">
              <Typography align="center" preset="body--small" style={{ width: '100%' }}>
                <Trans i18nkey="common:join_club_attendance">
                  You need to join this club before you can set your attendance
                </Trans>
              </Typography>
            </Cushion>
            <Button theme="primary">
              <TokenRedirect route="join">
                <Trans i18nkey="common:join_club">Join this club</Trans>
              </TokenRedirect>
            </Button>
          </FlexContainer>
        </Cushion>
      </ScrollBox>
    </Rectangle>
  </Panel>
);

JoinClubPanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default JoinClubPanel;
